import axios from "@/axios.js";

// Bloc signature HTML des emails commerciaux (logo par langue, site, reseaux,
// mentions FSC/ISO, logos de salons). Extrait de quotation/OperationView.vue ou
// il etait duplique verbatim dans plusieurs vues ; `signerName` permet en plus
// de signer du nom de la personne rattachee au devis.

const LANG_CONFIG = {
  fr: {
    logo: 'ab_fr.png',
    name: 'ACACIA BOIS',
    phone: 'Mobile BE:',
    phoneNumber: '+32 473 233 337',
    exhibitionTitle: 'Nous exposons:'
  },
  en: {
    logo: 'ab_en.png',
    name: 'ACACIA POLES',
    phone: 'Mobile BE:',
    phoneNumber: '+32 473 233 337',
    exhibitionTitle: 'Exhibiting:'
  },
  ro: {
    logo: 'ab_ro.png',
    name: 'STALPI SALCAM',
    phone: 'Mobile RO:',
    phoneNumber: '+40 748 263 345',
    exhibitionTitle: 'Expozăm:'
  },
  es: {
    logo: 'ab_es.png',
    name: 'ESTACAS DE ACACIA',
    phone: 'Móvil BE:',
    phoneNumber: '+32 473 233 337',
    exhibitionTitle: 'Exponemos:'
  },
  de: {
    logo: 'ab_de.png',
    name: 'ROBINIENPFÄHLE',
    phone: 'Handy DE:',
    phoneNumber: '+49 176 982 479 66',
    exhibitionTitle: 'Wir stellen aus:'
  },
  ne: {
    logo: 'ab_nl.png',
    name: 'ROBINIA PALEN',
    phone: 'Mobiel BE:',
    phoneNumber: '+32 473 23 33 37',
    exhibitionTitle: 'Wij exposeren:'
  }
};

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * @param {string} language  code ou nom de langue ('fr', 'Nederlands', ...)
 * @param {string} [signerName]  nom affiche au-dessus de la marque ; si vide,
 *                               la signature reste celle de la marque seule.
 * @returns {Promise<string>} HTML de la signature, '' en cas d'erreur.
 */
export async function getSignatureQuote(language, signerName = null) {
  try {
    const lang = String(language || '').substring(0, 2).toLowerCase();
    // La langue arrive soit en code ('nl'), soit en nom ('Nederlands' -> 'ne')
    // selon l'ecran : sans cet alias, un client neerlandais retombait sur la
    // signature anglaise (logo ACACIA POLES) sous un corps de mail en NL.
    const config = LANG_CONFIG[lang === 'nl' ? 'ne' : lang] || LANG_CONFIG.en;

    // Fetch exhibition images
    let exhibitionHtml = '';
    try {
      const response = await axios.get('https://xylo.codesinn.com/signature/salon_selection.json');
      const selectedImages = response.data.selected_images || [];

      if (selectedImages.length > 0) {
        const timestamp = Date.now();
        const imageHtml = selectedImages.map(imageName => `
              <div style="margin-bottom: 10px; padding: 8px; background-color: #fff; border: 1px solid #ddd;">
                <div style="margin-bottom: 8px; text-align: center;">
                  <img src="https://xylo.codesinn.com/signature/upload/${imageName}?t=${timestamp}" alt="Salon Logo" style="display: block; max-width: 100%; height: auto;" />
                </div>
              </div>
            `).join('');

        exhibitionHtml = `
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
            <td align="left" style="padding: 0;">
                <table width="420" cellpadding="0" cellspacing="0" border="0" style="width: 420px; border-collapse: collapse; font-family: Arial, sans-serif; color: #333; margin-top: 10px; border: 1px solid #e0e0e0; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td style="padding: 8px; background-color: #f8f9fa; border-top: 2px solid #0073b1;">
                            <div style="font-size: 13px; font-weight: bold; color: #0073b1; margin-bottom: 8px; text-align: left;">
                                    ${config.exhibitionTitle}
                            </div>

                            ${imageHtml}

                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    `;
      }
    } catch (error) {
      console.error('Error fetching exhibition images:', error);
    }

    const signerHtml = signerName
      ? `<div style="font-size: 14px; color: #333; font-weight: bold; margin-bottom: 2px;">${escapeHtml(signerName)}</div>`
      : '';

    // Generate main signature HTML
    return `<div style="text-align: left; width: 100%; margin: 0;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
        <tr>
            <td align="left" style="padding: 0;">
                <table width="420" cellpadding="0" cellspacing="0" border="0" style="width: 420px; border-collapse: collapse; font-family: Arial, sans-serif; color: #333; line-height: 1.4; border-top: 2px solid #0073b1; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                    <tr>
                        <td style="vertical-align: middle; padding: 10px 15px 10px 10px; width: 120px;">
                            <img src="https://xylo.codesinn.com/image/${config.logo}" alt="${config.name} Logo" style="display: block;" />
                        </td>
                        <td style="vertical-align: top; padding: 10px 10px 10px 0;">

                            ${signerHtml}

                            <div style="font-size: 13px; color: #333; font-weight: bold; margin-bottom: 8px;">${config.name}</div>


                            <div style="margin-bottom: 8px;">

                                <div><a href="https://www.acaciabois.com" target="_blank" style="text-decoration: none; color: #0073b1;">www.acaciabois.com</a></div>
                            </div>

                            <div style="margin-bottom: 0;">
                                <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
                                    <tr>
                                        <td style="padding-right: 8px; vertical-align: middle;">
                                            <a href="https://www.instagram.com/acaciabois/" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/instagram.png" alt="Instagram" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                        <td style="padding-right: 8px; vertical-align: middle;">
                                            <a href="https://www.facebook.com/acacia.bois.piquets/" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/facebook.png" alt="Facebook" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                        <td style="padding-right: 8px; vertical-align: middle;">
                                            <a href="https://www.linkedin.com/company/acacia-bois" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/linkedin.png" alt="LinkedIn" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                        <td style="vertical-align: middle;">
                                            <a href="https://g.page/r/CQ5mo8xGMDriEBM/review" target="_blank" style="text-decoration: none;">
                                                <img src="https://xylo.codesinn.com/image/google.png" alt="Google" style="display: block; border: 0;" />
                                            </a>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="padding: 10px; border-top: 1px solid #ccc;">
                            <div style="font-size: 9px; color: #777; text-align: left; line-height: 1.2;">
                                FSC &reg; CERTIFIED (SGSCH-COC-011793) | ISO9001-2015 CERTIFIED
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>

${exhibitionHtml}
    </div>`;
  } catch (error) {
    console.error('Error generating signature:', error);
    return '';
  }
}
